import ReactGA from "react-ga4";
// documentation for react-ga4: https://www.npmjs.com/package/react-ga4
export const initGA = (trackingID) => {
    ReactGA.initialize(trackingID);
    ReactGA.set({ anonymizeIp: true });
};

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */
export const Event = (category, action, label) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
    });
};
